













































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import CreateUnit from "./create-unit.vue";
import EditUnit from "./edit-unit.vue";
import adminColumns from "./admin-unit-columns";
import columns from "./unit-columns";
import actionColumns from "@/views/components/action-column";
import _ from "lodash";

class PageUnitRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  isUnitMaster: boolean;
}

@Component({
  components: { CreateUnit, EditUnit },
})
export default class Units extends mixins(ListMixin, AbpBase) {
  edit() {
    this.editModalShow = true;
  }
  namespace = "unit";
  clients = [];
  //filters
  pagerequest: PageUnitRequest = new PageUnitRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get store() {
    return this.$store.state.unit;
  }
  isClient() {
    return !Util.isNull(this.$store.state.session.client);
  }
  isTenant() {
    return !_.isNil(this.$store.state.session.tenant);
  }
  get client() {
    return this.$store.state.session.client;
  }
  get clientCode() {
    return this.isClient() ? this.$store.state.session.client.code : null;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: {
          hasAllItem: true,
        },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        this.pagerequest.clientCode =
          this.clients.length > 0 ? this.clients[0].code : "";
      });
  }
  get list() {
    var re = this.$store.state.unit.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: "unit/export",
      data: this.pagerequest,
    });
  }
  create() {
    this.createModalShow = true;
  }
  importUnit() {
    this.$router.push({ path: "unit/import" });
  }
  editUnit(row) {
    this.$store.commit("unit/edit", row);
    this.editModalShow = true;
  }
  removeUnit(row) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("DeleteUnitConfirm"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        await this.$store.dispatch({
          type: "unit/delete",
          data: row,
        });
        Util.showSuccessMsg(this, "Success.DeleteUnitSucc");
        await this.getpage();
      },
    });
  }
  async preGetPage() {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
  }
  importUnits() {
    this.$router.push({ path: "../grpclient/import-unit" });
  }
  renderColumns() {
    if (this.isClient()) {
      return [...columns, ...actionColumns];
    }
    if (this.isTenant()) {
      return adminColumns.concat(columns);
    }
    return [...adminColumns.concat(columns), ...actionColumns];
  }
  get columns() {
    return [
      {
        title: this.L("Order"),
        width: 65,
        key: "orderNo",
      },
      ...this.renderColumns(),
    ];
  }
  async created() {
    await this.getClients();
  }
}
